module.exports = __webpack_public_path__ + "img/24.9e31fd1a.jpg";